<div class="community-header">
  <div class="logo-block">
    @if (showBackButton()) {
      @if (isInternalPage()) {
        <app-button-back [straight]="true" text="" />
      } @else {
        <button class="mobile-menu-button" [dataTest]="'btn-sidebar-menu'" (click)="openMainSidebar()" aria-label="Toggle community menu">
          <span class="icon-menu-mobile menu-icon"></span>
        </button>
      }
    }
    <app-community-logo/>
  </div>
  <div class="profile-block" [class.hide-on-chat-mobile]="isChatRoute">
    <app-login-profile-block
      [showUserMenu]="showUserMenu"
      (toggleUserMenu)="toggleUserMenu()"
    />
  </div>
  @if (!isGuest && isChatRoute) {
    <button
      class="mobile-threads-button mobile-menu-button"
      [class.is-open]="sidebarService.isChatSidebarOpen()"
      (click)="openChatSidebar()"
      aria-label="Toggle chat sidebar"
    >
        <span class="icon-thread-list menu-icon"></span>
    </button>
  }
</div>
